import { AlertTitle, ColoredAlert } from '@bpinternal/ui-kit-next'
import { useSuspenseQuery } from '@tanstack/react-query'
import { CircleAlertIcon } from 'lucide-react'
import { DateTime } from 'luxon'
import { useMemo } from 'react'
import { listInvoicesQueryOptions } from '~/queries'
import { useCustomerPortal } from '../hooks'

type Props = {
  workspaceId: string
}

export const UnpaidInvoiceCallout = ({ workspaceId }: Props) => {
  const { invoices } = useSuspenseQuery(listInvoicesQueryOptions(workspaceId)).data
  const unpaidInvoices = useMemo(
    () =>
      invoices?.filter(
        (invoice) =>
          invoice.paymentStatus === 'open' && invoice.dueDate && DateTime.fromISO(invoice.dueDate) < DateTime.now()
      ),
    [invoices]
  )

  const { mutate: openCustomerPortal } = useCustomerPortal(workspaceId)

  return unpaidInvoices.length > 0 ? (
    <ColoredAlert color="red">
      <CircleAlertIcon className="size-5" />
      <AlertTitle className="mb-0 text-sm">
        Your workspace has an unpaid invoice. Please{' '}
        <a href="#" onClick={() => openCustomerPortal()} className="font-medium text-red-12 underline">
          pay your invoice
        </a>{' '}
        to restore full functionality.
      </AlertTitle>
    </ColoredAlert>
  ) : null
}
